import { appConfig, resolveApiUrl } from '../config/env'
import { clearSession, getToken } from './session'
import { getClientDeviceId } from '../services/device'

// 所有会员调用使用 Web 独立令牌；旧会话返回不能覆盖新会话。
export async function request(path, { method = 'GET', data, auth = true } = {}) {
  const token = getToken()
  if (auth && !token) throw new Error('请先登录')
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 20000)
  try {
    const response = await fetch(resolveApiUrl(`/v1/web${path}`), {
      method,
      signal: controller.signal,
      headers: {
        Accept: 'application/json',
        'X-Client-Version': '1.0.0',
        'X-Device-Id': getClientDeviceId(),
        ...(data instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
        ...(appConfig.siteCode ? { 'X-Site-Code': appConfig.siteCode } : {}),
        ...(token && auth ? { token, Authorization: `Bearer ${token}` } : {}),
      },
      ...(data === undefined ? {} : { body: data instanceof FormData ? data : JSON.stringify(data) }),
    })
    const payload = await response.json().catch(() => null)
    if (auth && token !== getToken()) throw new Error('登录账号已变化，请刷新页面')
    if (!response.ok || !payload || Number(payload.code) !== 0) {
      const message = payload?.message || `请求失败（${response.status}），请重试`
      if (auth && (response.status === 401 || Number(payload?.code) === 10024 || /请先登录|登录状态.*(?:失效|无效)|账号状态或凭据已变化/.test(message))) {
        clearSession()
        window.dispatchEvent(new Event('app:auth-expired'))
      }
      throw new Error(message)
    }
    return payload.result
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('请求超时，请重试')
    if (error instanceof TypeError) throw new Error('网络连接失败，请重试')
    throw error
  } finally { clearTimeout(timeout) }
}
